import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { type SelectFilterOptionValue } from '@/components/select-filter/constants'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import { type ValueOf } from '@/lib/utils/type'

import { type CASE_ARCHIVE_STATUS_MAP } from '../constants'
import type { ResGetCaseStatusBreakdown, ResGetCaseTypeBreakdown } from './types'

export const getCaseStatusBreakdownQuery = ({
  assignees,
  tags,
  archiveStatus,
  tagCondition,
}: {
  assignees: string[]
  tags: string[]
  archiveStatus: ValueOf<typeof CASE_ARCHIVE_STATUS_MAP>
  tagCondition: SelectFilterOptionValue
}) =>
  queryOptions({
    queryKey: [API_ENDPOINTS.business.v1.analysis.case.status.index, assignees, tags, archiveStatus, tagCondition],
    queryFn: (): Promise<ResGetCaseStatusBreakdown> => {
      return w
        .post(
          {
            assigneeCondition: 'or',
            tagCondition,
            assignees: assignees.map((x) => Number(x)),
            tags,
            archiveStatus,
          },
          API_ENDPOINTS.business.v1.analysis.case.status.index
        )
        .json()
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  })

export const getCaseTypeBreakdownQuery = ({
  assignees,
  tags,
  archiveStatus,
  tagCondition,
}: {
  assignees: string[]
  tags: string[]
  archiveStatus: ValueOf<typeof CASE_ARCHIVE_STATUS_MAP>
  tagCondition: SelectFilterOptionValue
}) =>
  queryOptions({
    queryKey: [API_ENDPOINTS.business.v1.analysis.case.type.index, assignees, tags, archiveStatus, tagCondition],
    queryFn: (): Promise<ResGetCaseTypeBreakdown> => {
      return w
        .post(
          {
            assigneeCondition: 'or',
            tagCondition,
            assignees: assignees.map((x) => Number(x)),
            tags,
            archiveStatus,
          },
          API_ENDPOINTS.business.v1.analysis.case.type.index
        )
        .json()
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  })
